"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Share = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var defaultSize = 18;

function Share(_a) {
  var children = _a.children,
      fill = _a.fill,
      _b = _a.size,
      size = _b === void 0 ? defaultSize : _b,
      props = tslib_1.__rest(_a, ["children", "fill", "size"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    width: size,
    height: size,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children, react_1.default.createElement("path", {
    d: "M10.9668 10.1186C6.32538 10.1186 1.62497 12.0853 1.13329 14.6322C1.09068 14.865 0.888179 15.0345 0.65145 15.0354H0.553115C0.435601 15.0352 0.322746 14.9894 0.238443 14.9075C0.17171 14.8131 0.140375 14.6982 0.149942 14.583C0.498056 8.83464 5.20879 4.32089 10.9668 4.21851V1.68146C10.9649 1.54814 11.0183 1.41997 11.1143 1.32746L11.311 1.13079C11.4033 1.03771 11.5289 0.985352 11.66 0.985352C11.7911 0.985352 11.9168 1.03771 12.0091 1.13079L17.7027 6.82438C17.7978 6.91361 17.8517 7.03818 17.8517 7.16855C17.8517 7.29893 17.7978 7.4235 17.7027 7.51273L12.0091 13.2063C11.9168 13.2994 11.7911 13.3518 11.66 13.3518C11.5289 13.3518 11.4033 13.2994 11.311 13.2063L11.1143 13.0097C11.0183 12.9171 10.9649 12.789 10.9668 12.6556V10.1186Z",
    fill: fill
  }));
}

exports.Share = Share;